import devicePixelRatio from './devicePixelRatio';
import * as Mixin from './util/mixin';
var canvas = {};
var canvas2D = {};

function registerCanvas(c, id) {
  canvas = c;
  canvas.id = id;

  if (!('tagName' in canvas)) {
    canvas.tagName = 'CANVAS';
  }

  canvas.type = 'canvas';
  Mixin.parentNode(canvas);
  Mixin.style(canvas);
  Mixin.classList(canvas);
  Mixin.clientRegion(canvas);
  Mixin.offsetRegion(canvas);

  canvas.focus = function () {};

  canvas.blur = function () {};
}

function registerCanvas2D(ctx, id) {
  var width = 1024;
  var height = 1024;
  canvas2D = {
    width: width,
    height: height,
    clientWidth: width / devicePixelRatio,
    clientHeight: height / devicePixelRatio,
    id: id,
    type: 'canvas'
  };

  if (!('tagName' in canvas2D)) {
    canvas2D.tagName = 'CANVAS';
  }

  Mixin.parentNode(canvas2D);
  Mixin.style(canvas2D);
  Mixin.classList(canvas2D);
  Mixin.clientRegion(canvas2D);
  Mixin.offsetRegion(canvas2D);

  canvas2D.getContext = function (type) {
    if (type === '2d') {
      return ctx;
    }
  };

  canvas2D.focus = function () {};

  canvas2D.blur = function () {};
}

function getCanvas() {
  return canvas;
}

function getCanvas2D() {
  return canvas2D;
}

export { registerCanvas, registerCanvas2D, getCanvas, getCanvas2D };
//# sourceMappingURL=register.js.map